import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '../../../../web/components-v2/Collapsible';
import { ChevronDown } from '../../../../web/components/svgs/icons/ChevronDown';
import { FollowUpBucket } from '../followUps';
import { styleSheet } from './styles';

interface IProps {
	bucket: FollowUpBucket;
	label: string;
	children: React.ReactNode;
}

export const FollowUpSection: React.FC<IProps> = ({ bucket, label, children }) => {
	const [open, setOpen] = React.useState(true);
	return (
		<section className={css(styleSheet.section)} aria-label={label}>
			<Collapsible open={open} onOpenChange={setOpen}>
				<CollapsibleTrigger render={<Button type='button' variant='ghost' styles={[styleSheet.sectionTrigger]} />}>
					<ChevronDown
						className={css(styleSheet.sectionChevron, !open && styleSheet.sectionChevronClosed)}
						width={14}
						height={14}
					/>
					<span className={css(styleSheet.sectionLabel, bucket === 'overdue' && styleSheet.sectionLabelOverdue)}>
						{label}
					</span>
				</CollapsibleTrigger>
				<CollapsiblePanel>{children}</CollapsiblePanel>
			</Collapsible>
		</section>
	);
};
